export default __webpack_public_path__ + "static/media/headerImage.2d1c66e1.svg";